import React from 'react';
import { BookOpen, ShoppingCart, Star, TrendingUp, Unlock } from 'lucide-react';
export function SolutionSection() {
  const benefits = [{
    icon: <BookOpen className="w-6 h-6 text-[#1a1008]" data-id="element-145" />,
    title: 'Recetas paso a paso desde cero',
    desc: 'Aprenderás sin necesidad de experiencia previa. Todo explicado al detalle.'
  }, {
    icon: <ShoppingCart className="w-6 h-6 text-[#1a1008]" data-id="element-146" />,
    title: 'Ingredientes económicos y fáciles',
    desc: 'Maximizá tus ganancias usando insumos que conseguís en cualquier supermercado.'
  }, {
    icon: <Star className="w-6 h-6 text-[#1a1008]" data-id="element-147" />,
    title: 'Técnicas de presentación',
    desc: 'Lográ que tus postres se vean profesionales y se vendan solos por la vista.'
  }, {
    icon: <TrendingUp className="w-6 h-6 text-[#1a1008]" data-id="element-148" />,
    title: 'Estrategias para vender',
    desc: 'No solo te enseñamos a cocinar, te enseñamos a crear un negocio rentable.'
  }, {
    icon: <Unlock className="w-6 h-6 text-[#1a1008]" data-id="element-149" />,
    title: 'Acceso de por vida',
    desc: 'Mirá las clases las veces que quieras, a tu propio ritmo y para siempre.'
  }];
  return <section id="solution" className="py-20 bg-gradient-to-b from-[#0d0906] to-[#140e0a]" data-id="element-150">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-151">
        <div className="text-center mb-16" data-id="element-152">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-153">
            Presentamos:{' '}
            <span className="gold-gradient-text" data-id="element-154">
              Curso Completo de Postres en Vaso
            </span>
          </h2>
          <p className="text-lg text-[#c9b99a] max-w-2xl mx-auto" data-id="element-155">
            El sistema probado para convertir algo simple en un ingreso extra
            constante.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-156">
          <div className="w-full lg:w-1/2" data-id="element-157">
            <div className="relative rounded-2xl overflow-hidden border border-[#d4a843]/20 shadow-[0_0_30px_rgba(212,168,67,0.15)] animate-float" data-id="element-158">
              <img src="https://cdn.magicpatterns.com/uploads/vTxXpkwnsCQZZt6FNWAvMr/ChatGPT_Image_11_mar_2026,_12_13_32_a.m..png" alt="Variedad de postres en vaso" className="w-full h-auto object-cover" data-id="element-159" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0d0906] via-transparent to-transparent opacity-60" data-id="element-160"></div>
            </div>
          </div>

          <div className="w-full lg:w-1/2 space-y-6" data-id="element-161">
            {benefits.map((benefit, index) => <div key={index} className="flex gap-4 items-start" data-id="element-162">
                <div className="mt-1 p-2 bg-gradient-to-br from-[#d4a843] to-[#f0c14b] rounded-lg shrink-0 shadow-lg" data-id="element-163">
                  {benefit.icon}
                </div>
                <div data-id="element-164">
                  <h3 className="text-xl font-bold text-white mb-1" data-id="element-165">
                    {benefit.title}
                  </h3>
                  <p className="text-[#c9b99a]" data-id="element-166">{benefit.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}